module.exports = __webpack_public_path__ + "static/media/add_to_drive_white_24dp.92255176.svg";